// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"ef5a5cfc","453":"81e8efb9","614":"9bb32ccb"}[chunkId] + ".chunk.js";
};